module.exports = __webpack_public_path__ + "img/water-sm.21a5462e.svg";